const CHECKOUT_OFFER_RE = /offer_ids(?:%5B%5D|\[\])?(?:=|%3D)(\d+)/i;
const PLANS_PATH_RE = /\/planos-de-assinatura/;
const CRAZY_EGG_SRC = 'https://script.crazyegg.com/pages/scripts/0130/8513.js';

const pushDataLayer = payload => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

const extractOfferIdFromHref = href => {
  if (!href) {
    return null;
  }
  const match = String(href).match(CHECKOUT_OFFER_RE);
  return match?.[1] || null;
};

const resolveCheckoutAnchor = target => {
  if (!target?.closest) {
    return null;
  }
  return target.closest('a[href*="checkout"]');
};

const isCheckoutCta = anchor => {
  if (!anchor?.href) {
    return false;
  }

  try {
    const url = new URL(anchor.href, window.location.origin);
    const isCheckoutPath = /\/(v2\/)?checkout\/?$/.test(url.pathname);
    const offerId = extractOfferIdFromHref(url.href);
    // Âncoras (#planos) não devem disparar add_to_cart.
    const isHashOnly =
      Boolean(url.hash) &&
      !offerId &&
      url.pathname === window.location.pathname;

    return isCheckoutPath && Boolean(offerId) && !isHashOnly;
  } catch (_error) {
    return false;
  }
};

const buildItemsFromGon = () => {
  const rawItems = window.gon?.plans_ecommerce_items;

  if (!Array.isArray(rawItems) || rawItems.length === 0) {
    return [];
  }

  return rawItems
    .map(item => ({
      item_id: String(item.item_id ?? item.id ?? ''),
      item_name: item.item_name || item.name || '',
      item_brand: 'Qconcursos',
      price: Number(item.price) || 0,
      discount: Number(item.discount) || 0,
      quantity: 1
    }))
    .filter(item => item.item_id);
};

const buildItemsFromDom = () => {
  const anchors = Array.from(
    document.querySelectorAll('a[href*="checkout"][href*="offer_ids"]')
  );
  const seen = new Set();

  return anchors
    .map(anchor => {
      const itemId = extractOfferIdFromHref(anchor.href);

      if (!itemId || seen.has(itemId)) {
        return null;
      }
      seen.add(itemId);

      return {
        item_id: itemId,
        item_name:
          anchor.getAttribute('aria-label') || anchor.textContent.trim(),
        item_brand: 'Qconcursos',
        quantity: 1
      };
    })
    .filter(Boolean);
};

const trackViewItemList = items => {
  if (!items.length || window.__qc_view_item_list_sent) {
    return;
  }

  window.__qc_view_item_list_sent = true;
  pushDataLayer({
    event: 'view_item_list',
    currency: 'BRL',
    items
  });
};

const trackAddToCart = item => {
  if (!item?.item_id) {
    return;
  }

  pushDataLayer({
    event: 'add_to_cart',
    currency: 'BRL',
    value: item.price || 0,
    items: [item]
  });
};

const bindAddToCartListener = itemById => {
  if (window.__qc_add_to_cart_listener_bound) {
    return;
  }
  window.__qc_add_to_cart_listener_bound = true;

  document.addEventListener(
    'click',
    event => {
      const anchor = resolveCheckoutAnchor(event.target);

      if (!isCheckoutCta(anchor)) {
        return;
      }

      const offerId = extractOfferIdFromHref(anchor.href);

      if (!offerId) {
        return;
      }

      const selected = itemById.get(String(offerId)) ||
        itemById.get(Number(offerId)) || {
          item_id: String(offerId),
          item_name: anchor.textContent.trim() || `Oferta ${offerId}`,
          item_brand: 'Qconcursos',
          quantity: 1
        };

      trackAddToCart(selected);
    },
    { capture: true }
  );
};

export const initPlansCrazyEgg = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  if (!PLANS_PATH_RE.test(window.location.pathname)) {
    return;
  }

  if (document.querySelector('builder-component')) {
    return;
  }

  if (document.querySelector(`script[src="${CRAZY_EGG_SRC}"]`)) {
    return;
  }

  const script = document.createElement('script');
  script.src = CRAZY_EGG_SRC;
  script.async = true;
  document.head.appendChild(script);
};

export const initPlansEcommerceTracking = () => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!PLANS_PATH_RE.test(window.location.pathname)) {
    return;
  }

  if (window.__qc_plans_ecommerce_initialized) {
    return;
  }

  window.__qc_plans_ecommerce_initialized = true;

  const items = buildItemsFromGon();
  const fallbackItems = items.length ? items : buildItemsFromDom();
  const itemById = new Map(
    fallbackItems.map(item => [String(item.item_id), item])
  );

  trackViewItemList(fallbackItems);
  bindAddToCartListener(itemById);
};

export const __testables = {
  extractOfferIdFromHref,
  isCheckoutCta,
  buildItemsFromDom
};
